import { Component, OnInit, Input } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'fgbcl-vimeo-player',
  standalone: true,
  imports: [],
  templateUrl: './vimeo-player.component.html',
  styleUrls: ['./vimeo-player.component.scss'],
})
export class VimeoPlayerComponent implements OnInit {
  @Input() streamKey: string;
  safeUrl: SafeResourceUrl;

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnInit() {
    this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + this.streamKey);
  }
}
